<template lang="pug">
v-form#trfExtForm(ref="trfExtForm", @submit.prevent="doSave", lazy-validation)
  v-container(grid-list-md)
    v-layout(wrap)
      v-flex(lg3, md3, xs12)
        f-select-bank-ext(
          v-model="list.data.bankCode",
          label="Bank Tujuan",
          :rules="[(v) => !!v || 'Masukan bank tujuan']",
          required,
          v-on:bankExt="bank = $event"
        )
      v-flex(lg2, md2, xs12)
        v-text-field(
          dense,
          v-model="list.customerId",
          v-numeric-only,
          label="No. Rekening",
          required,
          :rules="[(v) => !!v || 'Masukan no rekening']"
        )
      v-flex(lg5, md5, xs12)
        v-text-field(
          dense,
          v-model="list.description",
          label="Nama",
          required,
          :rules="[(v) => !!v || 'Masukan nama rekening']"
        )
      v-flex(lg12, md12, xs12)
        v-layout(wrap)
          v-flex(lg4, md4, xs12)
            f-radio-destination-ext(v-model="list.data.parameters.recvType")
          v-flex(lg4, md4, xs12)
            f-radio-resident-ext(v-model="list.data.parameters.recvResident")
          v-flex(lg4, md4, xs12)
            f-radio-nation-ext(v-model="list.data.parameters.recvCitizen")

    .ma-2.menu-btn(justify-center, style="text-align: center")
      v-btn.mx-1(@click="doCancel") Kembali
        v-icon mdi-arrow-left
      v-btn.mx-1(
        color="btnprimary white--text",
        type="submit",
        form="trfExtForm"
      ) Simpan
        v-icon mdi-content-save-outline
</template>
<script>
export default {
  name: "FTransferExternalListForm",
  props: ["productId", "productGroup"],
  data() {
    return {
      list: {
        customerId: "",
        description: "",
        data: {
          dest: {
            bankCode: "",
            bankName: "",
            account: "",
            name: "",
          },
          parameters: {},
        },
      },
      bank: null,
    };
  },
  mounted() {
    this.doReset();
  },
  methods: {
    doReset() {
      if (this.$refs.trfExtForm) {
        this.$refs.trfExtForm.resetValidation();
      }
      this.list = {
        customerId: "",
        description: "",
        data: {
          dest: {
            bankCode: "",
            bankName: "",
            account: "",
            name: "",
          },
          parameters: {},
        },
      };
      this.bank = null;
    },
    doSave() {
      if (this.$refs.trfExtForm.validate()) {
        this.list.data.dest.bankCode = this.bank.sknCode;
        this.list.data.dest.bankName = this.bank.initialName;
        this.list.data.dest.account = this.list.customerId;
        this.list.data.dest.name = this.list.description;
        this.$emit("list", this.list);
        this.doReset();
      }
    },
    doCancel() {
      this.$emit("cancel");
      this.doReset();
    },
  },
};
</script>